import { Badge, Image, Switch, Td, Text, Tr, useColorModeValue, Button, HStack } from "@chakra-ui/react";
import { useState, useRef } from "react";
import { FaPlay, FaStop } from "react-icons/fa";

function BellTableRow(props) {
    const { sn, bellSetup } = props;
    const textColor = useColorModeValue("gray.700", "white");
    const bgStatus = useColorModeValue("gray.400", "#1a202c");
    const colorStatus = useColorModeValue("white", "gray.400");

    const [isPlaying, setIsPlaying] = useState(false);
    const audioRef = useRef(new Audio(bellSetup?.url));

    const handlePlayPause = () => {
        if (isPlaying) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        } else {
            audioRef.current.play();
        }
        setIsPlaying(!isPlaying);
    };

    return (
        <Tr>
            <Td>
                <Text fontSize="md" color={textColor} fontWeight="bold">
                    {sn}
                </Text>
            </Td>

            <Td>
                <Text fontSize="sm" fontWeight="bold" color="gray.600" whiteSpace="normal" wordBreak="break-word">
                    {bellSetup?.name}
                </Text>
            </Td>
            <Td>
                <Text fontSize="sm" fontWeight="bold" color="gray.600" whiteSpace="normal" wordBreak="break-word">
                    {bellSetup?.type}
                </Text>
            </Td>
            <Td>
                <HStack>
                    <Button onClick={handlePlayPause} leftIcon={isPlaying ? <FaStop /> : <FaPlay />} colorScheme={isPlaying ? "red" : "blue"}>
                        {isPlaying ? "Stop" : "Play"}
                    </Button>
                </HStack>
            </Td>
            <Td>
                <Switch isChecked={Boolean(bellSetup?.enabled)}/>
            </Td>

            <Td>
                <Badge
                    bg={bellSetup?.status === "Y" ? "green.400" : bellSetup?.status === "P" ? "yellow.400" : bellSetup?.status === "B" ? "red.400" : "green.400"}
                    color={bellSetup?.status === "N" ? "white" : colorStatus}
                    fontSize="16px"
                    p="3px 10px"
                    borderRadius="8px"
                >
                    {bellSetup?.status === 'Y' ? "Active" : bellSetup?.status === "B" ? "Blocked" : bellSetup?.status === "P" ? "Pending" : "Active"}
                </Badge>
            </Td>
        </Tr>
    );
}

export default BellTableRow;